const picture = (filename) => `/Assets/pictures/${encodeURI(filename)}`;

export const SITE_ASSETS = {
  logo: picture('Sizzle Legacies - FAVICON AND LOGO GPBTY.png'),
  favicon: picture('Sizzle Legacies - FAVICON AND LOGO GPBTY.png'),
  features: {
    guidedQuestions: picture('Features Section - Guided Questions GPBTY.png'),
    recordYourWay: picture('Features Section - Record Your Way GPBTY.png'),
    automaticallyEdited: picture('Features Section - Automatic Video GPBTY.png'),
    saveAndShare: picture('Features Section - Save and Share GPBTY.png'),
  },
  photos: {
    familyPortrait: picture('Website Photo Option GPBTY - 1.png'),
    legacyTree: picture('Website Photo Option GPBTY - 2.png'),
    familyTree: picture('Website Photo Option GPBTY - 3.png'),
    colorfulTree: picture('Website Photo Option GPBTY - 4.png'),
    grandmother: picture('Website Photo Option GPBTY - 5.png'),
    storyBook: picture('Website Photo Option GPBTY - 6.png'),
    familyJourney: picture('Website Photo Option GPBTY - 7.png'),
    culturalCooking: picture('Website Photo Option GPBTY - 8.png'),
    familyMealEast: picture('Website Photo Option GPBTY - 9.png'),
    familyDinner: picture('Website Photo Option GPBTY - 10.png'),
  },
};
